const preOrderConstraints = Object.freeze({
  max: {
    groupOrderName: 50,
  },
})

export default preOrderConstraints
